import React, {Suspense} from 'react';
import './App.css';
import {useSessionContext} from "./util/SessionContext";
import {createDefaultTheme} from "./theme";
import {StyledEngineProvider, ThemeProvider} from '@mui/material';
import {AppContextProvider} from "./util/AppContext";
import {useSsoLogin} from "./util/useSsoLogin";
import Layout from "./components/Layout";
import InactiveLogout from "./components/Logout/InactiveLogout";
import SelectPersonaDialog from "./components/Login2/SelectPersonaDialog";
import SsoHandoffFailed from "./components/Login2/SsoHandoffFailed";
import SelectSsoAccountDialog from "./components/Login2/SelectSsoAccountDialog";
import SharedDocumentPage from "./pages/SharedDocumentPage";
import {shareFromPath} from "./util/sharedLink";

function App() {
    const sessionContext = useSessionContext();
    const {processing: ssoProcessing, selectingPersona, onPersonaSelected, failed: ssoFailed, fault: ssoFault, faultCode: ssoFaultCode,
           chooserAccounts, chooserSubmitting, onAccountChosen,
           preferredAccountUsid, onSignIn} = useSsoLogin(sessionContext);

    const theme = createDefaultTheme();
    // A CUSTOMER PORTAL CONTACT, handed over to read one shared document: no staff session, no layout, no sign-in.
    const sharedDocument = shareFromPath(window.location.pathname);
/*
    useEffect(() => {
        if (!sessionContext.valid()) {
            if (sessionContext.size() > 0) {
                console.log(`session is not valid but has content... resetting. ${JSON.stringify(sessionContext.dump())}`);
                sessionContext.reset();
            }
        }
    }, [sessionContext]);
*/
    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
                <Suspense fallback={<div>Loading...</div>}>
                    <AppContextProvider value={{sessionContext}}>
                        {sharedDocument ? (
                            <SharedDocumentPage share={sharedDocument}/>
                        ) : ssoProcessing ? (
                            <div style={{display: "flex", alignItems: "center", justifyContent: "center", height: "100vh"}}>Signing you in…</div>
                        ) : ssoFailed ? (
                            <SsoHandoffFailed onSignIn={onSignIn} fault={ssoFault} code={ssoFaultCode}/>
                        ) : chooserAccounts ? (
                            <SelectSsoAccountDialog accounts={chooserAccounts} submitting={chooserSubmitting}
                                                    preferredAccountUsid={preferredAccountUsid} onChoose={onAccountChosen}/>
                        ) : selectingPersona ? (
                            <SelectPersonaDialog onSelected={onPersonaSelected}/>
                        ) : (
                            <>
                                <Layout/>
                                <InactiveLogout/>
                            </>
                        )}
                    </AppContextProvider>
                </Suspense>
            </ThemeProvider>
        </StyledEngineProvider>
    );
}

export default App;
